<div [formGroup]="serviceInputsForm" [ngClass]="{ 'insert-input': !readOnly }">
    <div formGroupName="requiredFormGroup" class="input-container time-range-container">
        <label class="input-label">{{ 'timeRange' | translate }} <span *ngIf="!readOnly" class="required-field"> *</span></label>
        <div class="input-cont input-content input">
            <mat-form-field>
                <mat-label>{{ 'startTime' | translate }}</mat-label>
                <input 
                    matInput 
                    [ngxTimepicker]="!readOnly ? startTimePicker : null"
                    formControlName="{{ startTimeInput.controlName }}"
                    (change)="onTimeRangeChange()"
                    [readonly]="readOnly"
                    placeholder="HH:mm"
                    [format]="24" 
                    required
                />
                <!-- <ngx-material-timepicker-toggle matSuffix [for]="startTimePicker"></ngx-material-timepicker-toggle> -->
                <ngx-material-timepicker
                    #startTimePicker   
                    [theme]="timepickerTheme"
                ></ngx-material-timepicker>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'endTime' | translate }}</mat-label>
                <input 
                    matInput 
                    [ngxTimepicker]="!readOnly ? endTimePicker : null"
                    formControlName="{{ endTimeInput.controlName }}"
                    (change)="onTimeRangeChange()"
                    [readonly]="readOnly"
                    placeholder="HH:mm"
                    [format]="24" 
                    required
                />
                <!-- <ngx-material-timepicker-toggle matSuffix [for]="endTimePicker"></ngx-material-timepicker-toggle> -->
                <ngx-material-timepicker 
                    #endTimePicker 
                    [theme]="timepickerTheme"
                ></ngx-material-timepicker>
            </mat-form-field>
          
        </div>

        <mat-hint class="hint-as-error" *ngIf="form.get(this.endTimeInput.controlName).hasError('startOrEndTimeIsRequired')">
            {{ timeInputRequiredMsg | translate }}
        </mat-hint>
        <mat-hint class="hint-as-error" *ngIf="form.get(this.endTimeInput.controlName).hasError('endTimeBeforeStartTimeError')">
            {{ endTimeInput.errorMessage | translate }}
        </mat-hint>
    </div>

   
</div>